import * as React from "react";
import Breadcrumb from "../components/breadcrumb";
import ResultsContent from "../components/store-locator/store-results";
import Layout from "../layout/layout";
import MobileFilter from "../components/store-locator/mobile-filter";
export default class LocatorView extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let NavList = [
            { Text: 'Shopping List', Link: '/Products/ShoppingList' },
            { Text: 'Store Locator', Link: '' }
        ];
        const { stores, selected, updateSelected, mapOptions, clusters, amenitesFilter, searchText } = this.props;
        return (React.createElement(Layout, null,
            React.createElement("div", { className: "main-search-result" },
                React.createElement(Breadcrumb, { NavList: NavList }),
                React.createElement("h1", null, "STORE LOCATOR"),
                React.createElement("div", { className: "show-more filter-mobile", onClick: this.props.updateMobileFilter },
                    "FILTER",
                    React.createElement("i", { className: "fa fa-plus" })),
                React.createElement(MobileFilter, { toggleMobile: this.props.mobileFilter, updateMobileToggle: this.props.updateMobileFilter, amenitesFilter: amenitesFilter, updateFilter: this.props.updateFilter, clearFilter: this.props.clearFilter, searchText: searchText, updateSearchText: this.props.updateSearchText }),
                React.createElement("div", { className: "mobile-filter-toggle" },
                    React.createElement("div", { className: !this.props.toggleMobile ? "active" : "", onClick: () => this.props.updateToggle(false) }, "List"),
                    React.createElement("div", { className: this.props.toggleMobile ? "active" : "", onClick: () => this.props.updateToggle(true) }, "Map")),
                React.createElement("div", { className: !this.props.toggleMobile ? "list-view" : "map-view" },
                    React.createElement(ResultsContent, { getLocation: this.props.getLocation, stores: stores, selected: selected, mapOptions: mapOptions, clusters: clusters, updateSelected: updateSelected, amenitesFilter: amenitesFilter, searchText: searchText, updateSearchText: this.props.updateSearchText, updateFilter: this.props.updateFilter, handleMapChange: this.props.handleMapChange, MarkerClick: this.props.MarkerClick, clusterMarkerClick: this.props.clusterMarkerClick, clearFilter: this.props.clearFilter, updateAddressText: this.props.updateAddressText })))));
    }
}
;
//# sourceMappingURL=store-locator.js.map